module.exports = __webpack_public_path__ + "static/media/tpn-target-audience.ff3a70f8.jpg";